import { render, staticRenderFns } from "./AppReviewableListItem.vue?vue&type=template&id=6804d6d6&scoped=true&"
import script from "./AppReviewableListItem.vue?vue&type=script&lang=js&"
export * from "./AppReviewableListItem.vue?vue&type=script&lang=js&"
import style0 from "./AppReviewableListItem.vue?vue&type=style&index=0&id=6804d6d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6804d6d6",
  null
  
)

export default component.exports